module.exports = __webpack_public_path__ + "static/media/g-3-c.5276bd8e.jpg";